<form #form="ngForm" autocomplete="off" *ngIf="reservationQuestions">
    <div *ngFor="let reservationQuestion of reservationQuestions">
        <div *ngIf="checkVisible(reservationQuestion)">
            <div *ngIf="reservationQuestion.questionType != ReservationQuestionType.Option 
                && reservationQuestion.questionType != ReservationQuestionType.VisibleOption">
                {{ reservationQuestion.question }}
                <span class="text-danger" *ngIf="reservationQuestion.isRequired">*</span>
            </div>

            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.Text
            || reservationQuestion.questionType == ReservationQuestionType.FirstName
            || reservationQuestion.questionType == ReservationQuestionType.LastName">
                <input class="form-control" [(ngModel)]="reservationQuestion.answer" #text="ngModel" name="text"
                    [required]="reservationQuestion.isRequired" (ngModelChange)="updateTicketReservation(form.invalid)"
                    (input)="checkForUrls(reservationQuestion.answer)" oninput="this.value = this.value.toUpperCase()">
                <div *ngIf="text.invalid && (text.dirty || text.touched)" class="text-danger">
                    <div *ngIf="text.errors.required">
                        {{ 'required' | translate }}
                    </div>
                </div>
                <div *ngIf="textInvalid" class="text-danger">
                    {{ 'invalid-text' | translate }}
                </div>
            </div>

            <!-- TODO: update personal ID validation -->
            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.PersonalId">
                <input class="form-control" [(ngModel)]="reservationQuestion.answer" #personalId="ngModel"
                    name="personalId" [required]="reservationQuestion.isRequired" pattern="^[0-9]{11}$" maxlength="11"
                    (ngModelChange)="updateTicketReservation(form.invalid)">
                <div *ngIf="personalId.invalid && (personalId.dirty || personalId.touched)" class="text-danger">
                    <div *ngIf="personalId.errors.required">
                        {{ 'personal-id-required' | translate }}
                    </div>
                    <div *ngIf="personalId.errors.pattern">
                        {{ 'invalid-personal-id' | translate }}
                    </div>
                </div>
            </div>

            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.PersonalIdLastNumbers">
                <input class="form-control" [(ngModel)]="reservationQuestion.answer" #PersonalIdLastNumbers="ngModel"
                    name="PersonalIdLastNumbers" [required]="reservationQuestion.isRequired" pattern="^[0-9]{5}$"
                    maxlength="5" (ngModelChange)="updateTicketReservation(form.invalid)">
                <div *ngIf="PersonalIdLastNumbers.invalid && (PersonalIdLastNumbers.dirty || PersonalIdLastNumbers.touched)"
                    class="text-danger">
                    <div *ngIf="PersonalIdLastNumbers.errors.required">
                        {{ 'personal-id-required' | translate }}
                    </div>
                    <div *ngIf="PersonalIdLastNumbers.errors.pattern">
                        {{ 'invalid-personal-id' | translate }}
                    </div>
                </div>
            </div>

            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.Email">
                <input class="form-control" [(ngModel)]="reservationQuestion.answer" #email="ngModel" name="email"
                    [required]="reservationQuestion.isRequired" email
                    (ngModelChange)="updateTicketReservation(form.invalid)"
                    oninput="this.value = this.value.toUpperCase()">
                <div *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger">
                    <div *ngIf="email.errors.required">
                        {{ 'email-required' | translate }}
                    </div>
                    <div *ngIf="email.errors.email">
                        {{ 'invalid-email' | translate }}
                    </div>
                </div>
            </div>

            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.PhoneNumber">
                <input class="form-control" [(ngModel)]="reservationQuestion.answer" #phone="ngModel" name="phone"
                    [required]="reservationQuestion.isRequired" minlength="7" maxlength="17"
                    pattern="^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$"
                    (ngModelChange)="updateTicketReservation(form.invalid)">
                <div *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="text-danger">
                    <div *ngIf="phone.errors.required">
                        {{ 'phone-number-required' | translate }}
                    </div>
                    <div *ngIf="phone.errors.pattern || phone.errors.minlength">
                        {{ 'invalid-phone-number' | translate }}
                    </div>
                </div>
            </div>

            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.VIN">
                <input class="form-control" [(ngModel)]="reservationQuestion.answer" #vin="ngModel" name="vin"
                    [required]="reservationQuestion.isRequired" minlength="17" maxlength="17"
                    (ngModelChange)="updateTicketReservation(form.invalid)">
                <div *ngIf="vin.invalid && (vin.dirty || vin.touched)" class="text-danger">
                    <div *ngIf="vin.errors.required">
                        {{ 'vin-required' | translate }}
                    </div>
                    <div *ngIf="vin.errors.minlength">
                        {{ 'invalid-vin' | translate }}
                    </div>
                </div>
            </div>

            <div *ngIf="reservationQuestion.questionType == ReservationQuestionType.Option">
                <div class="my-2">
                    <mat-radio-group color="primary" [(ngModel)]="reservationQuestion.answer"
                        [ngModelOptions]="{standalone: true}">
                        <mat-radio-button [value]="FIRST_OPTION">{{ reservationQuestion.question.split(';')[0] }}
                        </mat-radio-button>
                        <mat-radio-button [value]="SECOND_OPTION">{{ reservationQuestion.question.split(';')[1] }}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
        </div>

        <div *ngIf="checkVisible(reservationQuestion) && reservationQuestion.questionType == ReservationQuestionType.VisibleOption">
            <div class="my-2">
                <mat-radio-group color="primary" [(ngModel)]="reservationQuestion.answer"
                    [ngModelOptions]="{standalone: true}">
                    <mat-radio-button [value]="FIRST_OPTION">{{ reservationQuestion.question.split(';')[0] }}
                    </mat-radio-button>
                    <mat-radio-button [value]="SECOND_OPTION">{{ reservationQuestion.question.split(';')[1] }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>
</form>